(function (app) {
    var src = document.querySelectorAll("script");
    var srcInfo = null;
    for (var i = 0; i < src.length; i++) {
        if (src[i].src.indexOf("/build/app.js") >= 0) // If using min files update to app.min.js
            srcInfo = src[i].src;
    }
    if (srcInfo != null) {
        var rel = srcInfo.substring(srcInfo.indexOf("rel=") + "rel=".length);
        app.config([
            "$templateRequestProvider", function ($templateRequestProvider) {
                $templateRequestProvider.httpOptions({
                    params: {
                        rel: rel
                    }
                });
            }
        ]);
    }
})(window.app); //jshint ignore:line